import { motion } from 'framer-motion';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const Logo = ({ size = 'md', showText = true }: LogoProps) => {
  // Size classes based on prop
  const sizeClasses = {
    sm: {
      container: 'h-8',
      logo: 'h-8',
      text: 'text-lg ml-2',
    },
    md: {
      container: 'h-10',
      logo: 'h-10',
      text: 'text-xl ml-2.5',
    },
    lg: {
      container: 'h-12',
      logo: 'h-12',
      text: 'text-2xl ml-3',
    },
  };
  
  return (
    <motion.div 
      className={`flex items-center ${sizeClasses[size].container}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Logo icon - rounded square with M */}
      <div className={`relative ${sizeClasses[size].logo} aspect-square rounded-lg bg-[#ff8c42] flex items-center justify-center shadow-md`}>
        <span className="text-white font-bold" style={{ fontSize: size === 'sm' ? '1rem' : size === 'md' ? '1.25rem' : '1.5rem' }}>
          M
        </span>
      </div>
      
      {/* Logo text */}
      {showText && (
        <div className={`${sizeClasses[size].text} font-bold text-[#694e42]`}>
          <span>Mail<span className="text-[#ff8c42]">maid</span></span>
        </div>
      )}
    </motion.div>
  );
};

export default Logo; 